import { render, staticRenderFns } from "./ListStudentPreview.vue?vue&type=template&id=56f3a698&scoped=true"
import script from "./ListStudentPreview.vue?vue&type=script&lang=js"
export * from "./ListStudentPreview.vue?vue&type=script&lang=js"
import style0 from "./ListStudentPreview.vue?vue&type=style&index=0&id=56f3a698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3a698",
  null
  
)

export default component.exports